import { useEffect } from "react";

// Copies each <th> text into data-label of its column cells so .ops-stack tables can render as cards on phones.
export function useStackTables() {
  useEffect(() => {
    let raf = 0;
    const label = () => {
      raf = 0;
      document.querySelectorAll(".ops-table.ops-stack").forEach((t) => {
        const heads = Array.from(t.querySelectorAll(":scope > thead th")).map((th) => th.textContent.replace(/[↓↑]/g, "").trim());
        t.querySelectorAll(":scope > tbody > tr").forEach((tr) => Array.from(tr.children).forEach((td, i) => {
          const l = td.colSpan > 1 ? "" : heads[i] || "";
          if (td.dataset.label !== l) td.dataset.label = l;
        }));
      });
    };
    label();
    const mo = new MutationObserver(() => { if (!raf) raf = requestAnimationFrame(label); });
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { mo.disconnect(); cancelAnimationFrame(raf); };
  }, []);
}
